import type React from 'react';

import classes from './ToolDisplay.module.css';

export interface ToolAwaitingInputProps {
  children: Exclude<React.ReactNode, boolean | null | undefined>[];
}

export function ToolAwaitingInput({ children }: ToolAwaitingInputProps) {
  if (!children?.length) {
    return null;
  }
  return <div className={classes.toolAwaitingInput}>{children}</div>;
}
